import axios from "axios";

export function getUser() {
  return axios.get(`/User`);
}

export function updateUser(firstName: string, lastName: string) {
  return axios.put(`/User`, { firstName, lastName });
}

export function updateUserWithNotification(payload: {
  firstName: string;
  lastName: string;
  email: string;
  sendNotification: boolean;
}) {
  return axios.put(`/User`, payload);
}

export function updatePin(oldPin: string, newPin: string) {
  return axios.put(`/User/pin`, { oldPin, newPin });
}

export function deleteUsersLinkedDevice() {
  return axios.post(`/User/delete/linked/device`);
}
